import { request } from "./api-require";
import { objAny } from "../common/common-interface";
const API_URL = "/basic-websocket/v1";

//召测费率/二维码
export const calledMeasurementFee = (data = {}, config: objAny = {}) => {
  return request(
    API_URL + "/collection/management/called_measurement/fee",
    data,
    config
  );
};
//滚动查询历史报文
export const getHistoryMessage = (data = {}, config: objAny = {}) => {
  return request(
    API_URL + "/collection/management/message/history",
    data,
    config
  );
};
//升级请求
export const calledUpgradeParam = (data = {}, config: objAny = {}) => {
  return request(
    API_URL + "/collection/management/called_measurement/upgrade",
    data,
    config
  );
};
//用户订阅WS主题
export const topicSubscribe = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/ws/topic/subscribe", data, config);
};
//发送Websocket消息
export const pushMsg = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/ws/push/msg", data, config);
};

//发送Websocket消息
export const updToken = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/ws/test/upd_token", data, config);
};
// /basic-websocket/v1/ws/test/upd_token
